module.exports = __webpack_public_path__ + "img/s2_t1_06.721fe6e1.jpeg";